import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersist from "pinia-plugin-persist";
import App from "./App.vue";
import router from "./router";
// import 'amfe-flexible'
import ElementPlus from "element-plus";
// import 'element-plus/dist/index.css'
// import 'element-plus/theme-chalk/dark/css-vars.css';
import "element-plus/theme-chalk/dark/css-vars.css";
import zhCn from "element-plus/es/locale/lang/zh-cn";
import Vue3DraggableResizable from "vue3-draggable-resizable";
import "vue3-draggable-resizable/dist/Vue3DraggableResizable.css";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import "./assets/css/main.scss";

// 本地SVG图标
import "virtual:svg-icons-register";
import "uno.css";
const app = createApp(App);
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component);
// }
app.use(createPinia().use(piniaPluginPersist));
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(ElementPlus, {
  locale: zhCn,
});
app.use(router).use(Vue3DraggableResizable);
app.mount("#app");
